(function($) {
    $.fn.extend({
        toggleText: function(a, b){
            return this.text(this.text() == b ? a : b);
        }
    });

    $(".nav-toggle").on('click', function () {
       $(this).toggleClass('show');
       $(".main-nav").toggleClass('active');
       $('.nav-toggle-text').toggleText('MENU', 'CLOSE');
       $nav = $("nav.mobile-nav");
       $nav.toggleClass('show');
       $("body").toggleClass('no-scroll');

    });

    $(".nav-close").on("click", function () {
        $nav = $("nav.mobile-nav");
        $nav.removeClass('show');
        $("body").removeClass('no-scroll');
    });

    $(".mobile-nav .nav-content .main ul li.menu-item-has-children > a").on('mouseover', function (e) {
        if($(window).width() >= 768) {
            e.preventDefault();
            e.stopPropagation();
            let $childMenuHolder = $(".mobile-nav .nav-content .child-menu ul");
            $children = $(this).parent('li').find(".sub-menu").html();
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $childMenuHolder.fadeOut(500).empty();
            } else {
                $(".mobile-nav .nav-content .main ul li.menu-item-has-children a.active").removeClass('active');
                $(this).addClass('active');
                $childMenuHolder.html($children).fadeIn(500);
            }
        }
    });

    $(".mobile-nav .nav-content .main ul li.menu-item-has-children > a").on('click', function(e) {
        if($(window).width() < 768) {
            $childMenu = $(this).parent('li').find('.sub-menu');
            if ($(this).hasClass('active')) {
                //
            } else {
                e.preventDefault();
                e.stopPropagation();
                $(".mobile-nav .nav-content .main ul li .active").removeClass('active');
                $(".mobile-nav .nav-content .main ul li .sub-menu").slideUp(600);
                $(this).addClass('active');
                $childMenu.slideDown(600).addClass('active');
            }
        }
    });

    $(window).on("scroll", function () {
        const $nav = $("nav.main-nav");
        if($(window).scrollTop() > $nav.outerHeight()) {
            $nav.addClass('fixed');
        } else {
            $nav.removeClass('fixed');
        }
    })


})( jQuery );

